const latest = {
    en: [
        {
            title: 'Digital Credential Acceptance Rate: What to Expect from Your Graduates and How to Raise It',
            description:
                'A one-off send to graduates starts at about 20% acceptance, the same at two different institutions. Inside an active program it reached 68%. What 30,441 credentials issued in Brazil say about where that gap comes from and how to close it.',
            date: '2026-10-20',
            image: '/images/blog/tasa-aceptacion-credenciales-egresados-pok.webp',
            author: 'POK Team',
            lang: 'en',
            slug: 'digital-credential-acceptance-rate-graduates-how-to-raise-it',
        },
        {
            title: 'How to Add Your Credential to LinkedIn So Recruiters Find You: The UniCesumar Method',
            description:
                'Most guides stop at "Licenses & certifications", which is the last step. The credential already holds the words a recruiter types: how UniCesumar taught its graduates to turn them into a headline, an About and a Skills list that get found.',
            date: '2026-10-08',
            image: '/images/blog/unicesumar-credencial-linkedin-pok.webp',
            author: 'POK Team',
            lang: 'en',
            slug: 'add-credential-to-linkedin-profile-keywords-unicesumar',
        },
        {
            title: 'Digital Certificates for Conferences: How Universidad Señor de Sipán Reached Its First Microcredential',
            description:
                'Designing, sending, storing and validating each certificate by hand does not scale, and the university ends up certifying what it can instead of what is worth certifying. How USS broke that process open, and why its first microcredential came after, not before.',
            date: '2026-09-21',
            image: '/images/blog/universidad-senor-de-sipan-credenciales-pok.webp',
            author: 'POK Team',
            lang: 'en',
            slug: 'digital-certificates-conferences-events-universidad-senor-de-sipan',
        },
    ],
    es: [
        {
            title: 'Tasa de aceptación de credenciales digitales: qué esperar de tus egresados y cómo aumentarla',
            description:
                'Un envío puntual a egresados arranca cerca del 20% de aceptación, igual en dos instituciones distintas. Dentro de un programa activo llegó al 68%. Lo que dicen 30.441 credenciales emitidas en Brasil sobre de dónde sale esa diferencia y cómo cerrarla.',
            date: '2026-10-20',
            image: '/images/blog/tasa-aceptacion-credenciales-egresados-pok.webp',
            author: 'POK Team',
            lang: 'es',
            slug: 'tasa-aceptacion-credenciales-digitales-egresados-como-aumentarla',
        },
        {
            title: 'Cómo agregar tu credencial a LinkedIn para que te encuentren: el método de UniCesumar',
            description:
                'Casi todas las guías terminan en "Licencias y certificaciones", que es el último paso. La credencial ya trae las palabras que escribe un reclutador: cómo UniCesumar enseñó a sus egresados a convertirlas en un titular, un "Acerca de" y unas aptitudes que se encuentran.',
            date: '2026-10-08',
            image: '/images/blog/unicesumar-credencial-linkedin-pok.webp',
            author: 'POK Team',
            lang: 'es',
            slug: 'como-agregar-credencial-linkedin-palabras-clave-unicesumar',
        },
        {
            title: 'Certificados digitales para congresos: cómo la Universidad Señor de Sipán llegó a su primera microcredencial',
            description:
                'Diseñar, enviar, almacenar y validar cada certificado a mano no escala, y la universidad termina certificando lo que puede en vez de lo que valdría la pena. Cómo la USS cortó ese proceso y por qué su primera microcredencial llegó después, no antes.',
            date: '2026-09-21',
            image: '/images/blog/universidad-senor-de-sipan-credenciales-pok.webp',
            author: 'POK Team',
            lang: 'es',
            slug: 'certificados-digitales-congresos-eventos-universidad-senor-de-sipan',
        },
    ],
    pt: [
        {
            title: 'Taxa de aceite de credenciais digitais: o que esperar dos seus egressos e como aumentá-la',
            description:
                'Um envio pontual a egressos começa perto de 20% de aceite, igual em duas instituições diferentes. Dentro de um programa ativo chegou a 68%. O que 30.441 credenciais emitidas no Brasil dizem sobre de onde vem essa diferença e como fechá-la.',
            date: '2026-10-20',
            image: '/images/blog/tasa-aceptacion-credenciales-egresados-pok.webp',
            author: 'POK Team',
            lang: 'pt',
            slug: 'taxa-aceite-credenciais-digitais-egressos-como-aumentar',
        },
        {
            title: 'Como adicionar sua credencial no LinkedIn para ser encontrado: o método da UniCesumar',
            description:
                'Quase todo guia termina em "Licenças e certificados", que é o último passo. A credencial já traz as palavras que um recrutador digita: como a UniCesumar ensinou seus egressos a transformá-las em um título, um Sobre e Competências que são encontrados.',
            date: '2026-10-08',
            image: '/images/blog/unicesumar-credencial-linkedin-pok.webp',
            author: 'POK Team',
            lang: 'pt',
            slug: 'como-adicionar-credencial-linkedin-palavras-chave-unicesumar',
        },
        {
            title: 'Certificados digitais para congressos: como a Universidad Señor de Sipán chegou à primeira microcredencial',
            description:
                'Desenhar, enviar, armazenar e validar cada certificado à mão não escala, e a universidade acaba certificando o que consegue em vez do que valeria a pena. Como a USS rompeu esse processo e por que a sua primeira microcredencial veio depois, não antes.',
            date: '2026-09-21',
            image: '/images/blog/universidad-senor-de-sipan-credenciales-pok.webp',
            author: 'POK Team',
            lang: 'pt',
            slug: 'certificados-digitais-congressos-eventos-universidad-senor-de-sipan',
        },
    ],
};

export function getLatestPosts(lang) {
    const posts = latest[lang] ?? latest.en;
    return posts.map((post) => ({
        ...post,
        link: lang === 'en' ? `/blog/posts/${post.slug}` : `/blog/${lang}/posts/${post.slug}`,
    }));
}
